import api from '../api';

export interface TrackingTarget { number_anno?: string; lot_id?: number }
export interface TrackerEntry {
  id: string;
  number_anno: string;
  tender_data?: Record<string, any> | null;
  has_discussion_protocol: boolean;
  created_at: string;
  updated_at?: string | null;
  notification?: Record<string, any> | null;
  delivery_status?: 'idle' | 'pending' | 'sent' | 'uncertain';
  pending_delivery_count?: number;
}
export interface TrackingPreview {
  number_anno: string;
  name_ru?: string | null;
  name_kz?: string | null;
  tracked: boolean;
  entry_id?: string | null;
  balance: number;
  cost: number;
  telegram_linked: boolean;
}
export async function previewTracking(target: TrackingTarget, signal?: AbortSignal): Promise<TrackingPreview> {
  return (await api.post('/tracker/preview', target, { signal, timeout: 20000 })).data;
}
export async function createTracking(target: TrackingTarget): Promise<TrackerEntry> {
  return (await api.post('/tracker/', target, { timeout: 25000 })).data;
}
export function trackingErrorKey(error: any): string {
  const status = error?.response?.status;
  const code = error?.response?.data?.detail?.code;
  if (code === 'telegram_required') return 'tracking.telegramRequired';
  if (status === 402) return 'tracking.noBalance';
  if (status === 404) return 'tracking.notFound';
  if (status === 400 || status === 422) return 'tracking.invalidNumber';
  if (status === 401) return 'tracking.loginRequired';
  if (status === 409) return 'tracking.retryConflict';
  if (status === 502 || status === 503 || status === 504) return 'tracking.sourceUnavailable';
  return 'tracking.requestFailed';
}
